import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const PrivateRoute = ({ component: Component }) => {
    const location = useLocation();
    
    return localStorage.getItem('auth')
        ? <Component />
        : <Navigate to="/" state={{ from: location }} replace />;
};